(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationLodgingComponentDetails',
	};

	var $form;

	var _getLodgingGroups,
	    _getAllInclusiveProperties,
	    _populateContactFields;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Get lodging groups and all-inclusive propertie when vendor is selected
		$('#reservationlodgingcomponentdetails-hotel_id').on('change', function change(e) {
			_getLodgingGroups($(this).val());
			_getAllInclusiveProperties($(this).val());
		});

		// automatically adjust the check out date from the check in date once a change occurs
		$('#reservationlodgingcomponentdetails-checkin_date-date').on('dp.change', function pickupChanged(event) {
			var startDate = event.date,
				endDate   = $('#reservationlodgingcomponentdetails-checkout_date-date').data('DateTimePicker');

			if (
				startDate
				&& (
					!endDate.date() ||
					(endDate && endDate.date() && endDate.date().isBefore(startDate) === true)
				)
			) {
				endDate.date(startDate.add(1, 'days'));
			}
		});

		// $('#reservationlodgingcomponentdetails-country_id').change(function countryChanged() {
		// 	if ($(this).val() === '183') {
		// 		$('#reservationlodgingcomponentdetails-state_id').removeAttr('disabled');
		// 	} else {
		// 		$('#reservationlodgingcomponentdetails-state_id').val('');
		// 		$('#reservationlodgingcomponentdetails-state_id').attr('disabled', 'disabled');
		// 	}
		// });

		$('#reservationlodgingcomponentdetails-set_final_payment_date').on('change', function change(e) {
			if ($(this).prop('checked') === true) {
				$form.find('.final-payment-date').removeClass('hidden');
				$form.find('.soft-payment-date').removeClass('hidden');
			} else {
				$form.find('.final-payment-date').addClass('hidden');
				$form.find('.soft-payment-date').addClass('hidden');
			}
		});

		// Auto-adjust final payment soft date when final payment due date is set
		$('#reservationlodgingcomponentdetails-final_payment_date').on('dp.change', function dateChange(event) {
			var $final_payment_date     = $(this),
				$soft_payment_date      = $('#reservationlodgingcomponentdetails-soft_payment_date'),
				soft_payment_date       = null,
				formatted_soft_date     = null,
				new_soft_payment_date   = null,
				formatted_new_soft_date = null;

			if ($final_payment_date.val() === $final_payment_date.data('current-value')) {
				return;
			}

			$final_payment_date.data('current-value', $final_payment_date.val());

			if (event.date) {
				soft_payment_date = $soft_payment_date.data('DateTimePicker');

				if (soft_payment_date && soft_payment_date.date()) {
					formatted_soft_date = soft_payment_date.date().format("M/D/YYYY");
				} else {
					formatted_soft_date = "(No date entered)";
				}

				new_soft_payment_date = event.date;
				new_soft_payment_date.subtract($soft_payment_date.data('soft-date-days'), 'days');
				formatted_new_soft_date = new_soft_payment_date.format('M/D/YYYY');

				Adzuki.CustomConfirm({
					title  : 'Change soft date?',
					content: 'Would you like to change the Final Soft Payment Date for this component from ' + formatted_soft_date + ' to ' + formatted_new_soft_date + ' (' + parseInt($soft_payment_date.data('soft-date-days')) + ' days before the Final Payment Date)? Click \'Yes\' to update the Final Payment Soft Date or \'No\' to keep the current Final Payment Soft Date.',
					confirm: function confirm() {
						soft_payment_date.date(new_soft_payment_date);
						// return true;
					}
				});
			}
		});

		// Toggle manual group entry fields when manual option
		// is selected from lodging group drop-down
		$('#reservationlodgingcomponentdetails-private_group_id').on('change', function onGroupIdChange(event) {
			if ($(event.target).val() === 'new') {
				$form.find('.create-group').removeClass('hidden');
			} else {
				$form.find('.create-group').addClass('hidden');
			}
		});

		_getLodgingGroups($('#reservationlodgingcomponentdetails-hotel_id').val());

		// Set lodging name and contact info when a property is selected from all-inclusive drop-down
		$('#reservationlodgingcomponentdetails-all_inclusive_property_id').on('change', function onPropertyIdChange(event) {
			_populateContactFields($(event.target).val());
		});


		Adzuki.Typeahead(
			'#reservationlodgingcomponentdetails-location_description',
			'/Searches/hotelSearch/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);

				if (item.giata_id) {
					$('#reservationlodgingcomponentdetails-giata_id').val(item.giata_id);

					Adzuki.Ajax.get(Adzuki.base_uri + '/HotelEngine/hotelMetaData/' + item.giata_id)
					.then(function success(response) {
						$('#reservationlodgingcomponentdetails-location_description').val(response.name);

						if (response.street_address_1) {
							$('#reservationlodgingcomponentdetails-address1').val(response.street_address_1);
							$('#reservationlodgingcomponentdetails-address2').val(response.street_address_2);
							$('#reservationlodgingcomponentdetails-city').val(response.city);
							$('#reservationlodgingcomponentdetails-zip').val(response.postal_code);

							// gets the country id
							if (response.country_code) {
								Adzuki.Ajax.get('/Searches/getCountryFromCountryCode/' + response.country_code).then(function success(country) {
									var selected_state = '',
									    $country_dd    = $('#reservationlodgingcomponentdetails-country_id');

									if (response.city_state_id.length) {
										selected_state = response.city_state_id;
									}

									$country_dd.val(country.country_id);
									Adzuki.Address.countryChange($country_dd, selected_state);
								});
							}
						}
					});
				}
			},
			function template(item) {
				var html;

				if (item.city) {
					html = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else if (item.street_address_1) {
					html = item.name + ' (' + item.street_address_1 + ')';
				} else {
					html = item.name;
				}
				return html;
			}
		);
	};

	_getLodgingGroups = function _getLodgingGroups(hotel_id)
	{
		var $lodging_groups  = $('#reservationlodgingcomponentdetails-private_group_id'),
		    private_group_id;

		$lodging_groups.empty();
		$lodging_groups.append($('<option>').text('--Not Part of a Group--').attr('value', ''));

		if (hotel_id === '') {
			return;
		}

		Adzuki.Ajax.get('/Reservations/getLodgingGroups/' + hotel_id).then(function success(optgroups) {
			var optgroup,
			    sorted_data;

			$.each(optgroups, function loadOptgroup(key, value) {
				optgroup = $('<optgroup>');

				if (key !== '0') {
					optgroup.attr('label', key);

					sorted_data = Adzuki.Sort.alphabeticValue(value);

					$.each(sorted_data, function loadLodgingGroup(i, lodging_group) {
						optgroup.append($('<option>').text(lodging_group.value).attr('value', lodging_group.key));
					});

					$lodging_groups.append(optgroup);
				}
			});

			if (typeof $lodging_groups.data('selected-id') !== 'undefined') {
				private_group_id = $lodging_groups.data('selected-id');
				$lodging_groups.removeAttr('data-selected-id');
				$lodging_groups.removeData('selected-id');

				$lodging_groups.val(private_group_id);

				$lodging_groups.trigger('change');
			}
		});
	};

	_getAllInclusiveProperties = function _getAllInclusiveProperties(hotel_id)
	{
		var $properties = $('#reservationlodgingcomponentdetails-all_inclusive_property_id'),
		    vendor_id,
		    property_id;

		// reset stuff
		$('#reservationlodgingcomponentdetails-location_description').val('');
		$('#reservationlodgingcomponentdetails-location_contact_phone').val('');
		$('#reservationlodgingcomponentdetails-country_id').val('');
		$('#reservationlodgingcomponentdetails-country_id').trigger('change');
		$('#all_inclusive_property_row').addClass('hidden');

		$properties.empty();
		$properties.append($('<option>').text('').attr('value', ''));

		if (hotel_id === '') {
			return;
		}

		// get vendor ID for hotel
		Adzuki.Ajax.get('/Vendors/getVendorId/lodging/hotels/' + hotel_id).then(function success(vendor) {
			vendor_id = vendor.vendor_id;

			Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + vendor_id).then(function success(properties) {
				var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

				if (sorted_properties.length > 0) {
					$.each(sorted_properties, function loadProperty(i, property) {
						$properties.append($('<option>').text(property.value).attr('value', property.key));
					});

					if (typeof $properties.data('selected-id') !== 'undefined') {
						property_id = $properties.data('selected-id');
						$properties.removeAttr('data-selected-id');
						$properties.removeData('selected-id');

						$properties.val(property_id);
					}

					$('#all_inclusive_property_row').removeClass('hidden');
				}
			});
		});
	};

	_populateContactFields = function _populateContactFields(property_id)
	{
		Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyDetails/' + property_id).then(function success(property) {
			// set lodging name
			$('#reservationlodgingcomponentdetails-location_description').val(property.name);

			// set contact info
			$('#reservationlodgingcomponentdetails-location_contact_phone').val(property.phone);

			// set country
			$('#reservationlodgingcomponentdetails-country_id').val(property.country_id);
			$('#reservationlodgingcomponentdetails-country_id').trigger('change');
		});
	};

}(jQuery, window.Adzuki || {}));
